import { useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import {
  street,
  city,
  state,
  zip,
  contactPath,
} from "../../constants";
import { ADDRESS_MAPS_URL } from "../../menu/menuShared";

const LAST_UPDATED = "August 27, 2026";

const RefundPolicy = () => {
  const theme = useTheme();

  const eyebrowStyle = {
    fontFamily: theme.typography.fontFamily,
    fontSize: "12px",
    fontWeight: 700,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    color: theme.palette.brand.brass,
    margin: "0 0 6px",
  };

  const headingStyle = {
    fontFamily: theme.typography.secondaryFontFamily,
    fontWeight: 600,
    color: theme.palette.primary.dark,
    fontSize: "min(9vw, 40px)",
    margin: "0 0 12px",
  };

  const sectionHeadingStyle = {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 700,
    fontSize: "17px",
    color: theme.palette.primary.dark,
    margin: "0 0 10px",
  };

  const bodyStyle = {
    fontFamily: theme.typography.paragraphFontFamily,
    fontSize: "15px",
    lineHeight: 1.7,
    color: theme.palette.text.primary,
    margin: "0 0 12px",
  };

  const sectionStyle = {
    padding: "24px 0",
    borderBottom: `1px solid ${theme.palette.brand.border}`,
  };

  const linkStyle = {
    color: theme.palette.primary.main,
    fontWeight: 600,
    textDecoration: "none",
  };

  return (
    <div
      style={{
        backgroundColor: theme.palette.background.default,
        fontFamily: theme.typography.fontFamily,
        paddingTop: "var(--nav-height)",
      }}
    >
      <div style={{ maxWidth: "720px", margin: "0 auto", padding: "36px 24px 64px" }}>
        <div style={eyebrowStyle}>Legal</div>
        <h1 style={headingStyle}>Refund Policy</h1>
        <p style={{ ...bodyStyle, color: theme.palette.text.secondary }}>
          This Refund Policy explains how Bethel Bible Church handles refund requests for gifts and
          donations given through bethelbibleoc.com (the "Site"). All giving is processed by Planning
          Center Giving through Church Center - Bethel does not process payments directly on the Site.
        </p>

        <div style={sectionStyle}>
          <h2 style={sectionHeadingStyle}>Gifts and donations</h2>
          <p style={bodyStyle}>
            Gifts and donations made to Bethel Bible Church are generally non-refundable. As with most
            churches and nonprofits, gifts are often committed to ministry use soon after they're
            received, which is why we can't offer refunds simply for a change of mind.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={sectionHeadingStyle}>Requesting a correction</h2>
          <p style={bodyStyle}>
            Mistakes happen - a duplicate charge, a wrong amount, or a gift given to the wrong
            fund. If something looks off, please contact us as soon as you notice; we'll look into it
            with Planning Center and make it right at our discretion wherever we reasonably can.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={sectionHeadingStyle}>Processing by a third party</h2>
          <p style={bodyStyle}>
            Because your gift is processed by Planning Center Giving rather than by Bethel directly,
            Planning Center's own terms govern the transaction itself, including any processing fees.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={sectionHeadingStyle}>Changes to this policy</h2>
          <p style={bodyStyle}>
            We may update this Refund Policy from time to time. When we do, we'll update the date at the
            bottom of this page. Continuing to give through the Site after a change means you accept the
            updated policy.
          </p>
        </div>

        <div style={{ padding: "24px 0" }}>
          <h2 style={sectionHeadingStyle}>Contacting us</h2>
          <p style={bodyStyle}>
            Questions about a gift or this policy? Reach us through our{" "}
            <Link to={contactPath} style={linkStyle}>
              Contact page
            </Link>
            , or in person:
          </p>
          <p style={{ ...bodyStyle, marginBottom: "4px" }}>
            <strong>Bethel Bible Church</strong>
          </p>
          <p style={bodyStyle}>
            <a href={ADDRESS_MAPS_URL} target="_blank" rel="noreferrer" style={linkStyle}>
              {street}, {city}, {state} {zip}
            </a>
          </p>
        </div>

        <p style={{ fontFamily: theme.typography.fontFamily, fontSize: "12px", color: theme.palette.text.secondary }}>
          Last updated {LAST_UPDATED}.
        </p>
      </div>
    </div>
  );
};

export default RefundPolicy;
